import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { projectIdGuard } from './guards/project-id.guard';

export const routes: Routes = [
  {
    path: 'signin',
    loadComponent: () => import('./auth/signin/signin.component').then((m) => m.SigninComponent),
  },
  {
    path: 'auth/invitation',
    loadComponent: () => import('./auth/invitation/invitation.component').then((m) => m.InvitationComponent),
  },
  {
    path: 'auth/reset-password',
    loadComponent: () => import('./auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'projects/new',
    loadComponent: () => import('./project/new-project/new-project.component').then((m) => m.NewProjectComponent),
    canActivate: [authGuard],
  },
  {
    path: 'projects/:projectId',
    loadComponent: () => import('./shell-layout/shell-layout.component').then((m) => m.ShellLayoutComponent),
    canActivate: [authGuard, projectIdGuard],
    runGuardsAndResolvers: 'paramsChange',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./bank-reconciliation/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'bank-reconciliation',
        loadComponent: () =>
          import('./bank-reconciliation/bank-reconciliation/bank-reconciliation.component').then((m) => m.BankReconciliationComponent),
      },
      {
        path: 'bank-reconciliation/create',
        loadComponent: () =>
          import('./bank-reconciliation/new-reconciliation/new-reconciliation.component').then((m) => m.NewReconciliationComponent),
      },
      {
        path: 'bank-reconciliation/:reconciliationId',
        loadComponent: () =>
          import('./bank-reconciliation/reconciliation-information/reconciliation-information.component').then(
            (m) => m.ReconciliationInformationComponent
          ),
      },
      {
        path: 'bank-reconciliation/:reconciliationId/:bankStatementId',
        loadComponent: () =>
          import('./bank-reconciliation/reconciliation-result/reconciliation-result.component').then((m) => m.ReconciliationResultComponent),
      },
      {
        path: 'bank-reconciliation/:reconciliationId/accounting/:accountingFileId',
        loadComponent: () =>
          import('./bank-reconciliation/reconcilitation-result-accounting-file/reconcilitation-result-accounting-file.component').then(
            (m) => m.ReconcilitationResultAccountingFileComponent
          ),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./configuration/configuration-roles/configuration-roles.component').then((m) => m.ConfigurationRolesComponent),
      },
      {
        path: 'configuration',
        children: [
          {
            path: 'bank-accounts',
            loadComponent: () =>
              import('./configuration/configuration-bank-account/configuration-bank-account.component').then(
                (m) => m.ConfigurationBankAccountComponent
              ),
          },
          {
            path: 'bank-reconciliation',
            loadComponent: () =>
              import('./configuration/configuration-bank-reconciliation/configuration-bank-reconciliation.component').then(
                (m) => m.ConfigurationBankReconciliationComponent
              ),
          },
          {
            path: 'project',
            loadComponent: () =>
              import('./configuration/configuration-project/configuration-project.component').then(
                (m) => m.ConfigurationProjectComponent
              ),
          },
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./configuration/configuration-dashboard/configuration-dashboard.component').then(
                (m) => m.ConfigurationDashboardComponent
              ),
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./configuration/configuration-users/configuration-users.component').then((m) => m.ConfigurationUsersComponent),
          },
          {
            path: 'my-account',
            loadComponent: () =>
              import('./configuration/configuration-my-account/configuration-my-account.component').then((m) => m.ConfigurationMyAccountComponent),
          },
          {
            path: 'ai',
            loadComponent: () =>
              import('./configuration/configuration-ai/configuration-ai.component').then((m) => m.ConfigurationAiComponent),
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'bank-accounts',
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'signin',
  },
];
